// extracted by mini-css-extract-plugin
module.exports = {"arrow":"styles_arrow__2wWgv","tooltip":"styles_tooltip__1GKmm","tooltipBody":"styles_tooltipBody__3ZN8b"};